import { RemoteGetAllCoursesUser } from 'data/usecases';
import { GetAllCoursesUserUseCaseInterface } from 'domain/usecases';
import { makeApiUrlCoursesUser } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllCoursesUser = (): GetAllCoursesUserUseCaseInterface =>
  new RemoteGetAllCoursesUser(makeApiUrlCoursesUser(), makeAxiosHttpClient());
